import script from "./BeatingHeartJourney.vue?vue&type=script&setup=true&lang=js"
export * from "./BeatingHeartJourney.vue?vue&type=script&setup=true&lang=js"

import "./BeatingHeartJourney.vue?vue&type=style&index=0&id=23ec62fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23ec62fa"]])

export default __exports__